{
  "familyId": "SWW-VT-VZFS",
  "questions": [
    {
      "id": "SWW-VT-VZFS-001",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'verven' (met verf schilderen)?",
      "context": null,
      "options": ["verfde", "vervde", "verftte", "verfte"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "verven",
            "stem": "verf",
            "lastLetter": "v",
            "useTE": false,
            "highlightLetters": ["v"],
            "result": "verfde",
            "note": "Kijk naar het hele werkwoord: verVen → v niet in kofschip → -de"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "V/F-wissel",
            "content": "Let op de v→f wissel! Het werkwoord is 'verVen' (met v), maar de stam is 'verf' (met f). Kijk naar het hele werkwoord: v niet in kofschip → -de.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "vz_fs_switch_verven",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: v/f-wisselregel. Stap 1: Het werkwoord is 'verVen' (met v). Stap 2: De stam is 'verf' (v→f wissel aan het eind). Stap 3: Kijk naar het hele werkwoord voor kofschip: 'verven' heeft een v, en v staat NIET in 't kofschip → dus -de. Stap 4: verf + de = verfde. Checkstrategie: kijk altijd naar het hele werkwoord (verven), niet naar de stam (verf), voor de kofschip-keuze.",
        "solutionSteps": [
          "Bepaal de stam: verven → verf (v→f wissel)",
          "Kijk naar het HELE werkwoord: verven heeft een v",
          "V staat NIET in kofschip → -de",
          "verf + de = verfde"
        ],
        "distractorExplanations": {
          "0": "Correct! V/f-wisselregel: kijk naar het hele werkwoord 'verven' (v niet in kofschip) → verf + de = verfde.",
          "1": "De stam is hier verkeerd geschreven. De stam is 'verf' (met f), niet 'verv'. De v→f wissel zorgt ervoor dat de v aan het eind van de stam een f wordt: verf + de = verfde.",
          "2": "Hier is naar de stam gekeken in plaats van het hele werkwoord. De stam 'verf' eindigt op f (in kofschip), maar je moet naar het hele werkwoord kijken: 'verven' heeft een v (niet in kofschip) → dus -de, niet -te.",
          "3": "Hier is naar de stam gekeken in plaats van het hele werkwoord. 'Verfte' gebruikt -te (alsof f in kofschip), maar de regel zegt: kijk naar het hele werkwoord 'verven' (v niet in kofschip) → -de: verfde."
        }
      }
    },
    {
      "id": "SWW-VT-VZFS-002",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "multiple_choice",
      "question": "Vul in: Vorige week ... we naar een nieuw huis. (verhuizen)",
      "context": null,
      "options": ["verhuisden", "verhuisten", "verhuurden", "verhuizden"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "verhuizen",
            "stem": "verhuis",
            "lastLetter": "z",
            "useTE": false,
            "highlightLetters": ["z"],
            "result": "verhuisden",
            "note": "Kijk naar het hele werkwoord: verhuiZen → z niet in kofschip → -den"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Z/S-wissel",
            "content": "Let op de z→s wissel! Het werkwoord is 'verhuiZen' (met z), maar de stam is 'verhuis' (met s). Kijk naar het hele werkwoord: z niet in kofschip → -de(n).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "vz_fs_switch_verhuizen",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Regel: z/s-wisselregel. Stap 1: Het werkwoord is 'verhuiZen' (met z). Stap 2: De stam is 'verhuis' (z→s wissel). Stap 3: Kijk naar het hele werkwoord: 'verhuizen' heeft een z, en z staat NIET in 't kofschip → dus -de(n). Stap 4: 'We' is meervoud: verhuis + den = verhuisden.",
        "solutionSteps": [
          "Bepaal de stam: verhuizen → verhuis (z→s wissel)",
          "Kijk naar het HELE werkwoord: verhuizen heeft een z",
          "Z staat NIET in kofschip → -de(n). 'We' is meervoud → -den",
          "verhuis + den = verhuisden"
        ],
        "distractorExplanations": {
          "0": "Correct! Z/s-wisselregel: kijk naar het hele werkwoord 'verhuizen' (z niet in kofschip) → verhuis + den = verhuisden.",
          "1": "Hier is naar de stam gekeken in plaats van het hele werkwoord. De stam 'verhuis' eindigt op s (in kofschip), maar je moet naar het hele werkwoord kijken: 'verhuizen' heeft een z (niet in kofschip) → -den, niet -ten.",
          "2": "Hier zijn werkwoorden verward. 'Verhuurden' komt van 'verhuren' (iets aan iemand geven voor geld). Hier gaat het om 'verhuizen' (naar een nieuw huis gaan): verhuisden.",
          "3": "De stam is hier verkeerd geschreven. De stam is 'verhuis' (met s), niet 'verhuiz'. De z→s wissel zorgt ervoor dat de z aan het eind van de stam een s wordt: verhuis + den = verhuisden."
        }
      }
    },
    {
      "id": "SWW-VT-VZFS-003",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist geschreven?",
      "context": null,
      "options": ["Ik reisde vorig jaar naar Spanje.", "Ik reizde vorig jaar naar Spanje.", "Ik reiste vorig jaar naar Spanje.", "Ik reysde vorig jaar naar Spanje."],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "reizen",
            "stem": "reis",
            "lastLetter": "z",
            "useTE": false,
            "highlightLetters": ["z"],
            "result": "reisde",
            "note": "Kijk naar het hele werkwoord: reiZen → z niet in kofschip → -de"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Z/S-wissel",
            "content": "Het werkwoord is 'reiZen' (met z). De stam is 'reis' (met s). Kijk naar het hele werkwoord: z niet in kofschip → -de.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "vz_fs_switch_reizen",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: z/s-wisselregel. Stap 1: Het werkwoord is 'reiZen' (met z). Stap 2: De stam is 'reis' (z→s wissel). Stap 3: Kijk naar het hele werkwoord: 'reizen' heeft een z, en z staat NIET in 't kofschip → dus -de. Stap 4: reis + de = reisde.",
        "solutionSteps": [
          "Bepaal de stam: reizen → reis (z→s wissel)",
          "Kijk naar het HELE werkwoord: reizen heeft een z",
          "Z staat NIET in kofschip → -de",
          "reis + de = reisde"
        ],
        "distractorExplanations": {
          "0": "Correct! Z/s-wisselregel: kijk naar het hele werkwoord 'reizen' (z niet in kofschip) → reis + de = reisde.",
          "1": "De stam is hier verkeerd geschreven. De stam is 'reis' (met s), niet 'reiz'. De z→s wissel zorgt ervoor dat de z een s wordt: reis + de = reisde.",
          "2": "Hier is naar de stam gekeken in plaats van het hele werkwoord. De stam 'reis' eindigt op s (in kofschip), maar je moet naar het hele werkwoord kijken: 'reizen' heeft een z (niet in kofschip) → -de, niet -te.",
          "3": "Hier is een verkeerde spelling gebruikt. 'Reizen' schrijf je met 'ei' (niet 'ey'). De juiste verleden tijd is: reis + de = reisde."
        }
      }
    },
    {
      "id": "SWW-VT-VZFS-004",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "multiple_choice",
      "question": "Vul in: Hij ... me dat hij zou komen. (beloven, verleden tijd)",
      "context": null,
      "options": ["beloofde", "belovde", "belooftte", "beloofte"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "beloven",
            "stem": "beloof",
            "lastLetter": "v",
            "useTE": false,
            "highlightLetters": ["v"],
            "result": "beloofde",
            "note": "Kijk naar het hele werkwoord: beloVen → v niet in kofschip → -de"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "V/F-wissel",
            "content": "Het werkwoord is 'beloVen' (met v). De stam is 'beloof' (v→f wissel). Kijk naar het hele werkwoord: v niet in kofschip → -de. beloof + de = beloofde.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "vz_fs_switch_beloven",
      "variantIndex": 4,
      "citoDifficulty": 0.37,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel: v/f-wisselregel. Stap 1: Het werkwoord is 'beloVen' (met v). Stap 2: De stam is 'beloof' (v→f wissel, plus de korte o wordt lang in open lettergreep → beloof). Stap 3: Kijk naar het hele werkwoord: 'beloven' heeft een v, en v staat NIET in 't kofschip → -de. Stap 4: beloof + de = beloofde. Checkstrategie: kijk altijd naar het hele werkwoord voor kofschip.",
        "solutionSteps": [
          "Bepaal de stam: beloven → beloof (v→f wissel)",
          "Kijk naar het HELE werkwoord: beloven heeft een v",
          "V staat NIET in kofschip → -de",
          "beloof + de = beloofde"
        ],
        "distractorExplanations": {
          "0": "Correct! V/f-wisselregel: kijk naar het hele werkwoord 'beloven' (v niet in kofschip) → beloof + de = beloofde.",
          "1": "De stam is hier verkeerd geschreven. De stam is 'beloof' (met f), niet 'belov'. De v→f wissel zorgt ervoor dat de v een f wordt: beloof + de = beloofde. Misconceptie: de v/f-wissel niet toepassen.",
          "2": "Hier is naar de stam gekeken in plaats van het hele werkwoord. 'Belooftte' gebruikt -te (alsof f in kofschip), maar kijk naar het hele werkwoord: 'beloven' heeft v (niet in kofschip) → -de: beloofde.",
          "3": "Hier is de stam verkort. 'Beloofte' mist de d van de uitgang -de. De stam is 'beloof' en de uitgang is -de: beloof + de = beloofde. Misconceptie: 'belofte' (zelfstandig naamwoord) verwarren met de verleden tijd."
        }
      }
    },
    {
      "id": "SWW-VT-VZFS-005",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "fill_in",
      "question": "Vul in: 'Zij ... van schaamte.' (blozen, verleden tijd enkelvoud) Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": "bloosde",
      "data": {
        "acceptedAnswers": ["bloosde"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [
        {
          "type": "kofschipMnemonic",
          "data": {
            "verb": "blozen",
            "stem": "bloos",
            "lastLetter": "z",
            "useTE": false,
            "highlightLetters": ["z"],
            "result": "bloosde",
            "note": "Kijk naar het hele werkwoord: bloZen → z niet in kofschip → -de"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Z/S-wissel",
            "content": "Het werkwoord is 'bloZen' (met z). De stam is 'bloos' (z→s wissel). Kijk naar het hele werkwoord: z niet in kofschip → -de. bloos + de = bloosde.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "vz_fs_switch_blozen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Regel: z/s-wisselregel. Stap 1: Het werkwoord is 'bloZen' (met z). Stap 2: De stam is 'bloos' (z→s wissel, plus de korte o wordt lang). Stap 3: Kijk naar het hele werkwoord: 'blozen' heeft een z, en z staat NIET in 't kofschip → -de. Stap 4: bloos + de = bloosde.",
        "solutionSteps": [
          "Bepaal de stam: blozen → bloos (z→s wissel)",
          "Kijk naar het HELE werkwoord: blozen heeft een z",
          "Z staat NIET in kofschip → -de",
          "bloos + de = bloosde"
        ]
      }
    },
    {
      "id": "SWW-VT-VZFS-006",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout? Klik op de zin met de spellingfout.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          {
            "text": "Wij verhuisten vorig jaar naar Amsterdam.",
            "hasError": true,
            "correction": "verhuisden",
            "explanation": "'Verhuizen' heeft een z → z niet in kofschip → -den (niet -ten). Juist: verhuisden."
          },
          { "text": "Hij verfde het hek gisteren.", "hasError": false },
          { "text": "Zij reisde naar Italië.", "hasError": false },
          { "text": "De kinderen bloosden van schaamte.", "hasError": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "V/F- en Z/S-wissel",
            "content": "Kijk altijd naar het HELE werkwoord voor kofschip. Verhuizen heeft een z (niet in kofschip) → -de(n). Verven heeft een v (niet in kofschip) → -de. Reizen heeft een z → -de. Blozen heeft een z → -de(n).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vz_fs_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Verhuisten' is fout. Bij de v/f- en z/s-wissel verandert de spelling in de stam (verhuiZen → verhuiS-), maar de kofschip-regel kijk je ALTIJD toe op het hele werkwoord. VerhuiZen heeft een z → z staat NIET in 't kofschip → dus -de(n), niet -te(n). Juist: verhuisden. Checkstrategie: schrijf het hele werkwoord op, onderstreep de laatste medeklinker vóór -en, en check of die in 't kofschip staat.",
        "solutionSteps": [
          "Stap 1: Schrijf het hele werkwoord: verhuiZen — de z is bepalend",
          "Stap 2: Staat z in 't kofschip? Nee → -de(n)",
          "Stap 3: Stam = verhuis + den = verhuisden (NIET verhuisten)",
          "Check de andere zinnen: verfde (verven, v → -de ✓), reisde (reizen, z → -de ✓), bloosden (blozen, z → -den ✓)",
          "Ezelsbruggetje: kijk altijd naar het HELE werkwoord, niet naar de stam!"
        ]
      }
    },
    {
      "id": "SWW-VT-VZFS-007",
      "familyId": "SWW-VT-VZFS",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_vz_fs_wissel",
      "questionType": "verb_conjugation_flow",
      "question": "Vervoeg 'verhuizen' naar de verleden tijd (enkelvoud).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "verb": "verhuizen",
        "targetForm": "verleden tijd (enkelvoud)",
        "context": "Hij ... gisteren naar een nieuwe stad. (verhuizen)",
        "finalAnswer": "verhuisde",
        "steps": [
          {
            "id": "step1",
            "prompt": "Kofschip-check op verhuiZen: krijg je -te of -de?",
            "type": "choice",
            "options": [
              { "label": "-te (z zit in 't kofschip)", "value": "te", "isCorrect": false, "feedback": "De z staat niet in 't kofschip → je krijgt -de." },
              { "label": "-de (z zit niet in 't kofschip)", "value": "de", "isCorrect": true }
            ]
          },
          {
            "id": "step2",
            "prompt": "Wat is de verleden tijd?",
            "type": "input",
            "acceptedAnswers": ["verhuisde"]
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Z/S-wissel",
            "content": "De stam is 'verhuis', maar voor 't kofschip kijk je naar het hele werkwoord: verhuiZen. De z staat niet in 't kofschip → +de → verhuisde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vz_fs_flow",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Kofschip-check op verhuiZen: de z staat niet in 't kofschip → +de. Stam 'verhuis' + de = verhuisde.",
        "solutionSteps": [
          "verhuiZen → z niet in kofschip → +de",
          "verhuis + de = verhuisde"
        ]
      }
    }
  ]
}